import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { CaptionText, H3, H4, P2, P3 } from '../../../styles/FontStyles';

import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../app/hooks';
import { Button, Flexed } from '../../../styles/GlobalComponents';
import { colors } from '../../../styles/GlobalStyles';
import { Overlay } from '../Overlay';
import { getMyHubsEntryOne } from '../Portfolio.actions';

import { GardianItem } from './GardianItem';
import { ENTRY_PACKAGE, SETTINGS_VIRTUAL_OFFICE } from '../../../routes/routes';
import { useHistory } from 'react-router';
import moment from 'moment';
import { getLicenses } from '../../Settings/Settings.actions';
import { dateDifferenceInDaysFromToday } from '../../../helpers/helperFunctions';

export const GuardianSummary = () => {
  // const [selectedOffer, setSelectedOffer] = useState(1);
  const dispatch = useDispatch();

  const history = useHistory();

  const { entryOne } = useAppSelector((state) => state.portfolio);

  const { licences } = useAppSelector((state) => state.settings);

  const { user } = useAppSelector((state) => state.auth.userInfo);

  const builderOfferLabel = `BUILDER OFFER · ENDS ${moment(
    entryOne?.futuraOfferEndDate
  ).format('DD MMM YYYY')} · ${entryOne?.futuraDaysRemaining} DAYS LEFT`;

  const licenceOfferLabel = `BUILDER OFFER · ENDS ${moment(
    entryOne?.offerEndDate
  ).format('DD MMM YYYY')} · ${entryOne?.daysRemaining} DAYS LEFT`;

  const builderNewOffers = [
    {
      isSelected: true,
      label: builderOfferLabel,
      title: 'Your first Futura fraction at 250 USDT',
      description:
        'One fraction at 250 USDT instead of 280 USDT. You have 30 days from buying the Builder plan to activate it. Purchase completes on Futura.',
      buttonText: 'Claim on Futura',
      note: 'Opens Futura with single sign-on',
      externalUrl: 'https://app.futura-mining.com/',
      requiresTwoLicences: null
    }
  ];

  const licenceNewOffers = [
    {
      isSelected: false,
      label: licenceOfferLabel,
      title: 'Back Office Subscription — first year 1 USDT',
      description:
        'Sell U1 products and take part in the rewards plan. Optional. Activate within 30 days of joining. Renews at 49 USDT per year.',
      buttonText: 'Add Back Office',
      note: 'Standard options: 49 / 1 year · 99 / 3 years',
      requiresTwoLicences: true
    }
  ];

  const getLastPackageExpiryDate = (orders: any[]) => {
    if (!orders || orders.length === 0) return null;

    const lastOrder = orders.find(
      (item) => item.productId !== 356 && item.productId !== 357
    );

    return moment(lastOrder.datePaid).add(3, 'years').format('DD MMM YYYY');
  };

  useEffect(() => {
    dispatch(getMyHubsEntryOne());
    dispatch(getLicenses());
  }, [dispatch]);

  useEffect(() => {}, [entryOne]);

  return (
    <>
      <Flexed mb='40' center between rowSM>
        <H3 mbSM='10' color={colors.primary900}>
          My Plans
        </H3>
      </Flexed>

      <div>
        {entryOne?.orders?.map((item: any, index: number) => {
          //NEW BUILDER
          if (item.productId === 357 && entryOne?.orders?.length === 1) {
            return (
              <>
                <GardianItem key={index} item={item} />
                {entryOne?.futuraDaysRemaining > 0 && (
                  <div>
                    {builderNewOffers
                      .filter(
                        (offer) =>
                          !offer.requiresTwoLicences || licences?.length === 3
                      )
                      .map((offer, index) => (
                        <OfferCard
                          key={index}
                          highlight={offer?.isSelected}
                          style={{ marginBottom: 20 }}>
                          <CaptionText
                            caps
                            bold
                            color={colors.primary900}
                            mb='8'>
                            {offer.label}
                          </CaptionText>
                          <H4 mb='8'>{offer.title}</H4>
                          <P2 color={colors.neutral500} mb='16'>
                            {offer.description}
                          </P2>
                          <OfferFooter gap='16px'>
                            {offer.externalUrl ? (
                              <a
                                href={offer.externalUrl}
                                target='_blank'
                                rel='noreferrer'>
                                <Button w='190px' h='40px'>
                                  {offer.buttonText}
                                </Button>
                              </a>
                            ) : (
                              <Button
                                w='190px'
                                h='40px'
                                onClick={() => {
                                  history.push(SETTINGS_VIRTUAL_OFFICE);
                                }}>
                                {offer.buttonText}
                              </Button>
                            )}
                            <P3 color={colors.neutral500}>{offer.note}</P3>
                          </OfferFooter>
                        </OfferCard>
                      ))}
                  </div>
                )}
                {entryOne?.daysRemaining > 0 && (
                  <div>
                    {licenceNewOffers
                      .filter(
                        (offer) =>
                          !offer.requiresTwoLicences || licences?.length === 3
                      )
                      .map((offer, index) => (
                        <OfferCard key={index} highlight={offer?.isSelected}>
                          <CaptionText
                            caps
                            bold
                            color={colors.primary900}
                            mb='8'>
                            {offer.label}
                          </CaptionText>
                          <H4 mb='8'>{offer.title}</H4>
                          <P2 color={colors.neutral500} mb='16'>
                            {offer.description}
                          </P2>
                          <OfferFooter gap='16px'>
                            <Button
                              w='190px'
                              h='40px'
                              onClick={() => {
                                history.push(SETTINGS_VIRTUAL_OFFICE);
                              }}>
                              {offer.buttonText}
                            </Button>
                            <P3 color={colors.neutral500}>{offer.note}</P3>
                          </OfferFooter>
                        </OfferCard>
                      ))}
                  </div>
                )}
              </>
            );
          }
          //NEW ACCESS
          else if (item.productId === 356) {
            return (
              <>
                <GardianItem key={index} item={item} />
                {licences?.length === 3 && entryOne?.daysRemaining > 0 && (
                  <OfferCard highlight={false} style={{ marginBottom: 20 }}>
                    <CaptionText caps bold color={colors.primary900} mb='8'>
                      {`ACCESS OFFER · ENDS ${moment(
                        entryOne?.offerEndDate
                      ).format('DD MMM YYYY')} · ${
                        entryOne?.daysRemaining
                      } DAYS LEFT`}
                    </CaptionText>
                    <H4 mb='8'>
                      Back Office Subscription — first year 33 USDT
                    </H4>
                    <P2 color={colors.neutral500} mb='16'>
                      Sell U1 products and take part in the rewards plan.
                      Optional. Activate within 30 days of joining. Renews at 49
                      USDT per year.
                    </P2>
                    <OfferFooter gap='16px'>
                      <Button
                        w='190px'
                        h='40px'
                        onClick={() => {
                          history.push(SETTINGS_VIRTUAL_OFFICE);
                        }}>
                        Add Back Office
                      </Button>
                      <P3 color={colors.neutral500}>
                        Standard options: 49 / 1 year · 99 / 3 years
                      </P3>
                    </OfferFooter>
                  </OfferCard>
                )}
              </>
            );
          } else {
            if (item.productId === 357) {
              return (
                <>
                  <GardianItem key={index} item={item} /> {}{' '}
                  {entryOne?.futuraDaysRemaining > 0 && (
                    <div>
                      {builderNewOffers
                        .filter(
                          (offer) =>
                            !offer.requiresTwoLicences || licences?.length === 3
                        )
                        .map((offer, index) => (
                          <OfferCard
                            key={index}
                            highlight={offer?.isSelected}
                            style={{ marginBottom: 20 }}>
                            <CaptionText
                              caps
                              bold
                              color={colors.primary900}
                              mb='8'>
                              {offer.label}
                            </CaptionText>
                            <H4 mb='8'>{offer.title}</H4>
                            <P2 color={colors.neutral500} mb='16'>
                              {offer.description}
                            </P2>
                            <OfferFooter gap='16px'>
                              {offer.externalUrl ? (
                                <a
                                  href={offer.externalUrl}
                                  target='_blank'
                                  rel='noreferrer'>
                                  <Button w='190px' h='40px'>
                                    {offer.buttonText}
                                  </Button>
                                </a>
                              ) : (
                                <Button
                                  w='190px'
                                  h='40px'
                                  onClick={() => {
                                    history.push(SETTINGS_VIRTUAL_OFFICE);
                                  }}>
                                  {offer.buttonText}
                                </Button>
                              )}
                              <P3 color={colors.neutral500}>{offer.note}</P3>
                            </OfferFooter>
                          </OfferCard>
                        ))}
                    </div>
                  )}
                  {entryOne?.daysRemaining > 0 && (
                    <div>
                      {licenceNewOffers
                        .filter((offer) => licences?.length === 3)
                        .map((offer, index) => (
                          <OfferCard
                            key={index}
                            highlight={offer?.isSelected}
                            style={{ marginBottom: 20 }}>
                            <CaptionText
                              caps
                              bold
                              color={colors.primary900}
                              mb='8'>
                              {offer.label}
                            </CaptionText>
                            <H4 mb='8'>{offer.title}</H4>
                            <P2 color={colors.neutral500} mb='16'>
                              {offer.description}
                            </P2>
                            <OfferFooter gap='16px'>
                              <Button
                                w='190px'
                                h='40px'
                                onClick={() => {
                                  history.push(SETTINGS_VIRTUAL_OFFICE);
                                }}>
                                {offer.buttonText}
                              </Button>

                              <P3 color={colors.neutral500}>{offer.note}</P3>
                            </OfferFooter>
                          </OfferCard>
                        ))}
                    </div>
                  )}
                </>
              );
            } else {
              if (index === 1) {
                return (
                  <>
                    <GardianItem key={index} item={item} />

                    <div>
                      <OfferCard
                        style={{ marginBottom: 20 }}
                        onClick={() => {
                          history.push(ENTRY_PACKAGE);
                        }}>
                        <CaptionText caps bold color={colors.primary900} mb='8'>
                          YOUR PLAN · VALID UNTIL{' '}
                          {getLastPackageExpiryDate(entryOne?.orders)}
                        </CaptionText>
                        <H4 mb='8'>
                          Everything in your plan stays until it ends
                        </H4>
                        <P2 color={colors.neutral500} mb='16'>
                          Your plan and all of its products continue to the end
                          of the paid term. Renewal options will be shared
                          before then. New members now choose Access or Builder.
                        </P2>
                        <OfferFooter gap='16px'>
                          <Button w='190px' h='40px'>
                            See Access & Builder
                          </Button>
                          <P3 color={colors.neutral500}>
                            No action needed today
                          </P3>
                        </OfferFooter>
                      </OfferCard>
                    </div>
                  </>
                );
              } else if (index === 0 && entryOne?.orders?.length === 1) {
                return (
                  <>
                    <GardianItem key={index} item={item} />

                    <div>
                      <OfferCard
                        style={{ marginBottom: 20 }}
                        onClick={() => {
                          history.push(ENTRY_PACKAGE);
                        }}>
                        <CaptionText caps bold color={colors.primary900} mb='8'>
                          YOUR PLAN · VALID UNTIL{' '}
                          {getLastPackageExpiryDate(entryOne?.orders)}
                        </CaptionText>
                        <H4 mb='8'>
                          Everything in your plan stays until it ends
                        </H4>
                        <P2 color={colors.neutral500} mb='16'>
                          Your plan and all of its products continue to the end
                          of the paid term. Renewal options will be shared
                          before then. New members now choose Access or Builder.
                        </P2>
                        <OfferFooter gap='16px'>
                          <Button w='190px' h='40px'>
                            See Access & Builder
                          </Button>
                          <P3 color={colors.neutral500}>
                            No action needed today
                          </P3>
                        </OfferFooter>
                      </OfferCard>
                    </div>
                  </>
                );
              } else if (entryOne?.orders?.length === 3) {
                return (
                  <>
                    <GardianItem key={index} item={item} />
                    <div>
                      <OfferCard
                        style={{ marginBottom: 20 }}
                        onClick={() => {
                          history.push(ENTRY_PACKAGE);
                        }}>
                        <CaptionText caps bold color={colors.primary900} mb='8'>
                          YOUR PLAN · VALID UNTIL{' '}
                          {getLastPackageExpiryDate(entryOne?.orders)}
                        </CaptionText>
                        <H4 mb='8'>
                          Everything in your plan stays until it ends
                        </H4>
                        <P2 color={colors.neutral500} mb='16'>
                          Your plan and all of its products continue to the end
                          of the paid term. Renewal options will be shared
                          before then. New members now choose Access or Builder.
                        </P2>
                        <OfferFooter gap='16px'>
                          <Button w='190px' h='40px'>
                            See Access & Builder
                          </Button>
                          <P3 color={colors.neutral500}>
                            No action needed today
                          </P3>
                        </OfferFooter>
                      </OfferCard>
                    </div>
                  </>
                );
              } else {
                return <GardianItem key={index} item={item} />;
              }
            }
          }
        })}
      </div>

      {entryOne?.orders?.length === 0 && (
        <P2 center color={colors.neutral500}>
          No data available
        </P2>
      )}

      <Overlay />
    </>
  );
};

const OfferCard = styled.div<{ highlight?: boolean }>`
  border-radius: 20px;
  padding: 20px 24px;
  margin-bottom: 16px;
  cursor: pointer;
  border: 1px solid
    ${({ highlight, theme }) =>
      highlight ? theme.colors.primary900 : theme.colors.neutral400};
  background: ${({ highlight, theme }) =>
    highlight ? `${theme.colors.primary900}1A` : theme.colors.neutral0};

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 800px) {
    padding: 16px;
  }
`;

const OfferFooter = styled(Flexed)`
  align-items: center;

  @media (max-width: 800px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
`;
